import request from '../../../utils/request';
import { NATIVE_MOCK } from '../../../utils';
import { getMockConfigWithConvert, getPanoramaPreviewParams } from '../utils';
import PanoramaMockData from './mock';

export function getPanoramaModuleConfig() {
  const preview = getPanoramaPreviewParams();
  if (preview) {
    return getMockConfigWithConvert();
  }

  const url = NATIVE_MOCK ? PanoramaMockData.projectConfigURL : './config.json';

  return request<any>({
    // 此请求baseURL必须为空字符串
    baseURL: '',
    url: url,
    method: 'get',
  });
}
